export var codeEnum = {
  tokenExpire: 102001,
  noGa: 101011,
  statusWrong: 101014
};
export var limit = {
  imgSize: 1024 * 1024 * 10
};
export var RULES = {
  npay: 'npay-customer-admin',
  customer: 'card-customer-admin'
};
export var configEnum = {
  rangeLimitDay: 0,
  tokenKey: 'token'
};
export var cookieNames = {
  acceptFlag: 'bycard-customer-accept',
  theme: 'bycard-theme'
};
export var pmsCodes = {
  card: 'cust:finance:manager',
  finance: 'cust:finance:manager',
  financeQuery: 'cust:finance:manager:basic',
  wallet: 'cust:wallet:manager',
  walletQuery: 'cust:wallet:manager:basic',
  walletWithdraw: 'cust:wallet:withdraw',
  systemSetting: 'cust:config:manager',
  systemSettingQuery: 'cust:config:manager:basic',
  openApiConfig: 'cust:config:openapi',
  webhookConfig: 'cust:config:webhooks',
  addWithdrawAddress: 'cust:config:address:add',
  deleteWithdrawAddress: 'cust:config:address:delete',
  apiDoc: 'cust:openapi:document',
  // card pay api文档
  npayFinance: 'cust:npay:finance:manager',
  npayFinanceQuery: 'cust:npay:finance:manager:basic',
  npaySystemSettings: 'cust:npay:config:manager',
  // npay机构配置
  npaySystemSettingsQuery: 'cust:npay:config:manager:basic',
  // npay 机构配置查询
  npayEditOpenApi: 'cust:npay:config:openapi',
  // npay 编辑open api
  npayApiDoc: 'cust:openapi:npay:document',
  // npay api doc
  // 推荐管理
  referrer: 'cust:recommend:manager',
  referrerQuery: 'cust:recommend:manager:basic',
  referrerWithdraw: 'cust:recommend:withdraw',
  // toc
  tocManage: 'cuser:cust:operation:manager',
  tocQuery: 'cuser:cust:operation:manager:basic'
};

// /v1/customers/asset/list
export var TxType = {
  // 备付金tx_type
  charge: '01',
  // 备付金充值
  withdraw: '02',
  // 备付金提现
  rewardWithdraw: '03',
  // 奖励金提现
  manualCharge: '04',
  // 手动充值 RUSD
  transfer: '97',
  // 划转
  reduce: '98',
  // 扣费
  upgradeReduce: '99' // 卡升级扣费
};
export var provisionType = {
  charge: 0,
  // 充值备付金
  open: 1 // 开卡备付金
};